import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhoneLoginComponent } from './phone-login/phone-login.component';
import { PinEntryComponent } from './pin-entry/pin-entry.component';
import { OtpEntryComponent } from './otp-entry/otp-entry.component';
import { RouterModule } from '@angular/router';
import { phoneLoginRoutes } from './phone-login.route';
import { NgOtpInputModule } from 'ng-otp-input';
import { LayoutModule } from '../../layout/layout.module';
import { NzCardModule, NzLayoutModule, NzStatisticModule } from 'ng-zorro-antd';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedCommonModule } from '../../shared/shared-common.module';
import { NgxMaskModule } from 'ngx-mask';
import {PinCreateComponent} from "./pin-create/pin-create.component";


@NgModule({
  declarations: [PhoneLoginComponent, PinEntryComponent, OtpEntryComponent, PinCreateComponent],
  imports: [
    CommonModule,
    SharedCommonModule,
    RouterModule.forChild(phoneLoginRoutes),
    NgxMaskModule.forRoot(),
    NzStatisticModule,
    LayoutModule,
    NzLayoutModule,
    NzCardModule,
    MatFormFieldModule,
    MatInputModule,
    NgOtpInputModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class PhoneLoginModule {
}
